<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>จัดการเจ้าหน้าที่</strong></v-card-title>
          </v-layout>

          <!-- <v-layout row wrap justify-end>
            <v-flex xs5 sm2 md2 lg2>
              <v-btn class="mx-2 px-3" outlined color="indigo lighten-2" @click="openadminmodal('')">
                <v-icon>mdi-plus</v-icon>&nbsp;
                เพิ่มเจ้าหน้าที่
              </v-btn>
            </v-flex>
          </v-layout> -->
          <br />
        <v-layout justify-center>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start align-center>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>username</strong></p>
                <v-text-field v-model="username_search" outlined clearable dense v-on:input="userfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อ-สกุล</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="userfilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                    <v-combobox
                      v-model="searchitem.model"
                      :items="searchitem.items"
                      :item-text="searchitem.itemtext"
                      :item-value="searchitem.itemtext"
                      :return-object="false"
                      hide-selected
                      outlined
                      clearable
                      dense
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="userfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
                <v-flex xs12 sm3 md3 lg3 px-3>
                  <v-layout align-end justify-end>
                    <div class="px-1">
                      <v-btn class="px-3" outlined color="indigo lighten-2" @click="openadminmodal('')">
                        <v-icon>mdi-plus</v-icon>&nbsp;เพิ่มเจ้าหน้าที่
                      </v-btn>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            <br />
          <v-data-table
            :headers="headers"
            :items="userdata_view"
            :items-per-page="10"
            class="elevation-3"
            :loading="loading"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openadminmodal(item._id)">{{ item.username }}</td>
                  <td @click="openadminmodal(item._id)">{{ item.name }}</td>
                  <td @click="openadminmodal(item._id)">{{ item.level }}</td>
                  <td>
                    <v-btn class="ma-2" outlined small fab color="pink lighten-2" @click="openadminmodal(item._id)">
                      <v-icon meduim>mdi-pencil</v-icon>
                    </v-btn>
                     <v-btn class="ma-2" outlined small fab color="red" @click="deleteadmin(item)">
                      <v-icon meduim>mdi-delete-forever</v-icon>
                    </v-btn>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <Adminmodal :parentgetdata="getdata" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Adminmodal from '@/components/Adminmodal'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import swal from 'sweetalert'
export default {
  components: {
    Adminmodal
  },
  data: () => ({
    headers: [
      { text: 'username', align: 'center', sortable: false, value: 'username' },
      { text: 'ชื่อ-สกุล', align: 'center', sortable: false, value: 'name' },
      { text: 'ระดับเจ้าหน้าที่', value: 'level', sortable: false, align: 'center' },
      { text: 'แก้ไข/ลบ', value: 'action', sortable: false, align: 'center' }
    ],
    userdatas: [],
    userdata_view: [],
    name_search: '',
    username_search: '',
    searchitems: [
      { text: 'ระดับเจ้าหน้าที่', items: [], itemtext: 'level', model: [] }
    ],
    loading: false
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    async getdata () {
      try {
        this.loading = true
        this.currentadmindata = ''
        let { data } = await axios.get(`${process.env.VUE_APP_API}/user/getinfo/admin`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.userdatas = data
        this.userdata_view = this.userdatas
        for (const searchitem of this.searchitems) {
          searchitem.items = searchitem.items.length === 0 ? this.userdatas : searchitem.items
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    async openadminmodal (id) {
      this.adminmodal = true
      this.currentadmindata = id !== '' ? JSON.stringify(this.userdatas.find(pd => pd._id === id)) : ''
    },
    async deleteadmin (item) {
      try {
        await swal({
          title: `คุณแน่ใจที่จะลบเจ้าหน้าที่ ${item.name} ?`,
          icon: 'warning',
          buttons: ['ยกเลิก', 'ลบ'],
          dangerMode: true
        })
          .then(async (willDelete) => {
            if (willDelete) {
              let { data } = await axios.delete(`${process.env.VUE_APP_API}/user/delete/${item._id}`, {
                headers: {
                  Authorization: this.$cookies.get('token')
                }
              })
              if (data) {
                await swal(`เจ้าหน้าที่ ${item.name} ถูกลบแล้ว!`, {
                  icon: 'success',
                  buttons: 'ตกลง'
                })
                this.getdata()
              }
            }
          })
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    userfilterfunction () {
      this.userdata_view = this.userdatas.filter(user => {
        let condition = [
          this.name_search ? (user.name.toLowerCase()).includes((this.name_search).toLowerCase()) : true,
          this.username_search ? (user.username.toLowerCase()).includes((this.username_search).toLowerCase()) : true,
          this.searchitems[0].model.includes(user.level) || !this.searchitems[0].model.length
        ]
        return condition.every(con => con)
      })
    }
  },
  computed: {
    adminmodal: sync('adminmodal'),
    currentadmindata: sync('currentadmindata')
  }
}
</script>

<style scoped >
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {

  height: 60px !important;
}
.v-data-table {
  font-family: 'Kanit';
}
.v-text-field {
  font-family: 'Kanit';
}

.v-btn {
  font-family: 'Kanit';
  font-weight: bold;
}

td {
  max-width: 80px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}

</style>
